import moment from "moment";
import _ from "lodash";

import {
  GET_MEMBER_EMAIL,
  GET_MEMBER_ID,
  GET_MEMBER_INFO,
  GET_MEMBER_IS_AUTH,
  GET_MEMBER_ROLE,
  GET_MEMBER_TYPE,
  GET_AUTH_MEMBER_TOKEN,
} from "./types";

export default {
  [GET_AUTH_MEMBER_TOKEN](state) {
    return state.token;
  },

  [GET_MEMBER_IS_AUTH]: (state) => {
    let statusLogin = state.accountLogin.isAuth,
      token = state.token,
      validExpiredAt = true;

    let pointNowTime = moment(),
      expiredAt = moment(parseInt(state.expired_at)).subtract(5, "minutes");

    if (!state.expired_at || pointNowTime.isSameOrAfter(expiredAt)) {
      validExpiredAt = false;
    }

    return !!(token && validExpiredAt && statusLogin == "success");
  },

  [GET_MEMBER_ID]: (state) => {
    if (!_.isEmpty(state.accountLogin.info)) {
      return Object.prototype.hasOwnProperty.call(state.accountLogin.info, "id")
        ? state.accountLogin.info.id
        : "";
    }
    return "";
  },

  [GET_MEMBER_EMAIL]: (state) => {
    if (!_.isEmpty(state.accountLogin.info)) {
      return Object.prototype.hasOwnProperty.call(
        state.accountLogin.info,
        "email"
      )
        ? state.accountLogin.info.email
        : "";
    }
    return "";
  },

  [GET_MEMBER_ROLE]: (state) => {
    if (!_.isEmpty(state.accountLogin.info)) {
      return Object.prototype.hasOwnProperty.call(
        state.accountLogin.info,
        "role_id"
      )
        ? state.accountLogin.info.role_id
        : "";
    }
    return "";
  },

  [GET_MEMBER_TYPE]: (state) => {
    if (!_.isEmpty(state.accountLogin.info)) {
      return Object.prototype.hasOwnProperty.call(
        state.accountLogin.info,
        "type_id"
      )
        ? state.accountLogin.info.type_id
        : "";
    }
    return "";
  },

  [GET_MEMBER_INFO]: (state) => {
    return state.accountLogin.info;
  },
};
